// Central content for NeuroPlay Counseling, LLC

export const HEADWAY = "https://care.headway.co/providers/dora-henderson-2";

export const PRACTICE = {
    name: "NeuroPlay Counseling, LLC",
    location: "Longwood, Florida",
    address: "1250 S US Hwy 17-92, Suite 150, Longwood, FL 32750",
    email: "asafespacellc@gmail.com",
    facebook:
        "https://www.facebook.com/A-Safe-Space-Counseling-LLC-772973679533657/",
    linkedin: "https://www.linkedin.com/in/dora-henderson-03302b10a/",
    mapUrl:
        "https://www.google.com/maps/search/?api=1&query=1250+S+US+Hwy+17-92+Suite+150+Longwood+FL+32750",
};

export const NAV = [
    { label: "Our Story", to: "/about" },
    { label: "Books", to: "/books" },
    { label: "Services", to: "/services" },
    { label: "Neuro's Game", to: "/#neuro-section" },
    { label: "Insurance", to: "/rates" },
    { label: "Trainings", to: "/trainings" },
    { label: "FAQs", to: "/faqs" },
    { label: "Visit", to: "/visit" },
    { label: "Contact", to: "/contact" },
];

export const FOOTER_LINKS = [
    { label: "Our Story", to: "/about" },
    { label: "Books", to: "/books" },
    { label: "Services", to: "/services" },
    { label: "Neuro's Game", to: "/#neuro-section" },
    { label: "Insurance", to: "/rates" },
    { label: "Trainings", to: "/trainings" },
    { label: "FAQs", to: "/faqs" },
    { label: "Visit", to: "/visit" },
    { label: "Contact", to: "/contact" },
    { label: "Client Portal", href: HEADWAY, external: true },
];

// 10 candle / directory items on the home page
export const DIRECTORY = [
    { n: "01", title: "Our Story / About Us", sub: "Dora Henderson, LMHC-QS, RPT-S", to: "/about" },
    { n: "02", title: "Therapist Books & Profiles", sub: "Sandi & Clammy and friends", to: "/books" },
    { n: "03", title: "Services & Specialties", sub: "Play Therapy, EMDR & Trauma", to: "/services" },
    { n: "04", title: "Book an Appointment", sub: "Secure booking via Headway", href: HEADWAY },
    { n: "05", title: "Insurance & Rates", sub: "$150 self-pay · most plans billed", to: "/rates" },
    { n: "06", title: "New Patient Forms", sub: "Intake through Headway", href: HEADWAY },
    { n: "07", title: "FAQs", sub: "What therapy feels like", to: "/faqs" },
    { n: "08", title: "Location & Hours", sub: "Longwood, Florida", to: "/visit" },
    { n: "09", title: "Client Portal / Login", sub: "Headway client account", href: HEADWAY },
    { n: "10", title: "Contact Us", sub: "We reply within a day", to: "/contact" },
];

// Candle positions overlaid on the hero room photo (percentages)
export const CANDLE_SPOTS = [
    { top: "40%", left: "16%" },
    { top: "46%", left: "23%" },
    { top: "48%", left: "30%" },
    { top: "42%", left: "38%" },
    { top: "50%", left: "45%" },
    { top: "40%", left: "53%" },
    { top: "44%", left: "61%" },
    { top: "38%", left: "72%" },
    { top: "26%", left: "78%" },
    { top: "24%", left: "94%" },
];

export const MARQUEE = [
    "Play Therapy",
    "EMDR",
    "Trauma-Informed Care",
    "Grief & Loss Support",
    "Anxiety Relief",
    "Children · Teens · Adults",
    "Neuro & the 'Ception Force Friends",
    "NeuroPlay Counseling",
];

export const FRIENDS = [
    { name: "Intero-Ception", tag: "Body Sense", sprite: "sprite-heart.png", color: "#38bdf8", title: "Knows where every arm and leg is, even with eyes closed." },
    { name: "Proprio-Ception", tag: "Inner Calm", sprite: "sprite-thermo.png", color: "#4ade80", title: "Hears the rumble of hungry tummies and the flutter of nervous hearts." },
    { name: "Equilibrio-Ception", tag: "Balance", sprite: "sprite-zen.png", color: "#c084fc", title: "Keeps everyone steady — spinning, swinging, never tipping over." },
    { name: "Noci-Ception", tag: "Touch Guard", sprite: "sprite-spike.png", color: "#fb7185", title: "Decides which textures are cozy and which are 'nope, not today'." },
    { name: "Extero-Ception", tag: "Sound Wave", sprite: "sprite-ears.png", color: "#facc15", title: "Turns noisy worlds down to a comfortable volume." },
    { name: "Neuro-Ception", tag: "Sparkle Eye", sprite: "sprite-neuro.png", color: "#f472b6", title: "Spots the details — and knows when bright lights are too much." },
    { name: "Thermo-Ception", tag: "Taste Delight", sprite: "sprite-tears.png", color: "#fb923c", title: "Adventurous taster, patient with picky eaters." },
    { name: "Vagus Nerve", tag: "Scent Breeze", sprite: "sprite-brainy.png", color: "#2dd4bf", title: "Smells cookies three rooms away. Also smells when socks are done." },
];

export const CREDENTIALS = [
    {
        title: "LMHC-QS · RPT-S",
        body: "Licensed Mental Health Counselor & Qualified Supervisor, and Registered Play Therapist-Supervisor — the field's highest play-therapy credential.",
    },
    {
        title: "Trauma-trained",
        body: "EMDR consultant-in-training, certified in TraumaPlay and the Safe & Sound Protocol, with years spent walking children and adults through grief, anxiety, and hard memories.",
    },
    {
        title: "Author & Trainer",
        body: "Creator of the Sandi & Clammy series, The Vagus Nerve, and the Neuro & the 'Ception Force Friends — and an APT- and EMDRIA-approved CE provider for fellow therapists.",
    },
];

export const TEAM = [
    { name: "Dora Henderson", creds: "M.A., LMHC-QS, RPT-S, CST", role: "Owner & Founder", img: "dora.jpg" },
    {
        name: "Shannon Stieg",
        creds: "M.Ed., M.A., LMHC",
        role: "Therapist",
        img: "team-shannon.jpg",
        specialties: [
            "Working towards Registered Play Therapist",
            "Single & divorced parents and their children",
            "Gifted & twice-exceptional children and adolescents",
        ],
        bio: [
            "I decided to become a counselor after more than a decade of working with middle and high school students as a teacher and tutor. I earned my Master's Degree in counseling, along with a certificate in Play Therapy, from the University of Central Florida in 2023, and I became licensed as an LMHC in 2026.",
            "Inspired by my years working as a private tutor, I am passionate about working collaboratively with children, adolescents, and their families to develop skills and overcome the various obstacles that life throws their way. I wholeheartedly believe that it takes a village to raise a family and that everyone can benefit from outside support.",
            "I am especially drawn to working with single parents, divorced parents, and gifted and twice-exceptional children and adolescents.",
            "Outside of the counseling room, I enjoy reading and audiobooks, Legos, puzzles, and spending time with family. I am easily distracted by dogs (and most other animals, too) and love to visit SeaWorld and zoos with my son.",
        ],
    },
    {
        name: "Ryan Uner",
        creds: "M.A., LMHC",
        role: "Therapist",
        img: "team-ryan.jpg",
        specialties: [
            "Working towards Registered Play Therapist",
            "EMDR & Sandtray Therapy",
            "Children, adolescents & families",
            "ADHD, Autism & Epilepsy support",
            "Trauma & medical trauma counseling",
            "Learning disabilities support",
            "Exceptional education & homeschool expertise",
        ],
        bio: [
            "My journey began as an educator working with children with learning disabilities, particularly ADHD and Autism. I found my passion for helping these kids, and that led me to transition from teaching to providing mental health counseling.",
            "I am dedicated to supporting children and adults with exceptional needs and neurodiversity, along with their families, fostering confidence and acceptance in their unique journeys.",
            "I have a deep passion for neuroscience and play therapy, using playful and creative approaches to make therapy engaging and effective for children and adults. I love helping people of all ages with trauma recovery, guiding them toward healing and resilience. One of my passion areas is working with kids with ADHD and/or Autism — I love helping them find their place in a world that doesn't always understand them.",
            "I love integrating the client's interests into the therapeutic experience. I believe in taking the passions and strengths of the client and using them to foster resilience and an understanding of who the client is.",
            "I accept some insurances and take the Step Up for Students scholarship.",
            "I now offer sword and archery therapy, for those interested in not just talking!",
        ],
    },
    {
        name: "Tessa Voorhees",
        creds: "M.S.W., RCSWI",
        role: "Clinical Social Work Intern",
        img: "team-tessa.jpg",
        specialties: [
            "Working towards licensure as an LCSW",
            "LGBTQIA+ & neurodiverse-affirming",
            "Autism, ADHD & OCD support",
            "Trauma-informed",
            "Integrative therapist",
        ],
        bio: [
            "As an autistic and ADHD (AuDHD) person myself, I know how important it is to have a therapeutic space that is inclusive and celebrates your strengths and uniqueness. Therapy with me is neurodivergent-affirming and LGBTQIA+ affirming. I love helping my clients understand themselves better, gain insight into their inner world, and build tools for healing and growth. Everyone has unique strengths, even during times that feel overwhelming or uncertain. I am here to help you build the skills to manage life's challenges and thrive.",
            "I support clients with Autism, ADHD, OCD, anxiety, depression, bipolar disorder, and trauma, starting from age five and up. Our journey together may involve playful strategies, expressive arts, Internal Family Systems concepts, Dialectical Behavior Therapy techniques, and mindfulness. All approaches are designed to be flexible and meet your individual needs.",
            "Therapy with me is a collaborative journey. Together, we will explore who you are, acknowledge what you have been carrying, and envision what you hope for the future. My goal is for you to feel truly seen, supported, and empowered as you create the life you desire.",
        ],
    },
    {
        name: "Hess",
        creds: "New Horizons Service Dogs",
        role: "Therapy Dog",
        img: "hess.jpg",
        specialties: [
            "Gentle companionship",
            "Calming presence",
            "Client comfort",
        ],
        bio: [
            "Meet Hess, our much-loved therapy dog at NeuroPlay Counseling! Hess joined us through New Horizons Service Dogs after being bitten by another dog. This special boy now brings gentle companionship to our practice and enjoys the love and affection clients give him.",
            "Because of his experience, Hess can feel fearful and react around other dogs. To help him feel safe, please keep pets at home. Service dogs are welcome, and we will move Hess to a separate area during your visit. If possible, please let us know ahead of time so we can prepare a comfortable space for everyone.",
            "Please know that a dog is regularly on-site. If you have a dog allergy or sensitivity, let us know before your appointment so we can discuss accommodations. Although Hess can stay in a separate area, dog allergens may still be present. Please follow your healthcare provider's guidance regarding any allergy medication you may need before visiting.",
        ],
    },
];

export const BOOKS = [
    {
        tag: "Children's Book",
        title: "Neuro & the 'Ception Force Friends",
        author: "Dora Henderson, MA, LMHC, RPT-S, CST · Illustrated by Heather Worley",
        body: "Meet the special team of receptor neurons that help your body and brain with regulation — neuroscience made friendly for little readers.",
        img: "books/neuro-ception.jpg",
        href: "https://www.amazon.com/Neuro-Ception-Force-Friends-regulation/dp/B09YQQK1PM",
    },
    {
        tag: "Children's Book",
        title: "The Vagus Nerve — My Special Friend!",
        author: "Dora Henderson, LMHC, RPT-S · Illustrated by Caitlynn Henderson",
        body: "A warm introduction to the body's calm-down superhighway, helping kids understand how their nervous system keeps them safe.",
        img: "books/vagus-nerve.jpg",
        href: "https://www.amazon.com/Vagus-Nerve-Special-Ception-Friends-ebook/dp/B0CPJQ94YT",
    },
    {
        tag: "'Ception Force Friends",
        title: "Polly Vagale — The Vagus Nerve Super-Highway",
        author: "Dora Henderson, LMHC-S, RPT-S, CST · Illustrated by Caitlynn Henderson, Carmen Luciano & Heather Worley",
        body: "Ride along the vagus nerve super-highway with Polly Vagale as she shows children how signals travel between body and brain.",
        img: "books/polly-vagale.jpg",
        href: "https://www.amazon.com/s?k=Polly+Vagale+Dora+Henderson",
    },
    {
        tag: "Edición en Español",
        title: "Las Aventuras de Sandi y Clammy",
        author: "por Dora Henderson · Ilustrado por Donna Coffee y Heather Worley · Traducido por Homan Machuca",
        body: "La edición en español de nuestra querida historia: Sandi y su tímido amigo Clammy presentan a los niños habilidades de autorregulación y diálogo interno positivo.",
        img: "books/sandi-clammy-es.jpg",
        href: "https://www.amazon.com/s?k=Las+Aventuras+de+Sandi+y+Clammy",
    },
    {
        tag: "Children's Book",
        title: "Social Skills with Sasquatch — Compassion in the City",
        author: "Ryan Uner, RMHCI",
        body: "A gentle, big-hearted story from our own Ryan Uner about kindness, connection, and finding compassion wherever you are.",
        img: "books/sasquatch.jpg",
        href: "https://www.amazon.com/s?k=Social+Skills+with+Sasquatch+Ryan+Uner",
    },
];

export const SERVICES = [
    { age: "Children 3–12", title: "Play Therapy", body: "Children speak through play. In a room built for them, toys become words and big feelings find a safe way out — guided by a Registered Play Therapist." },
    { age: "Teens & Adults", title: "EMDR Therapy", body: "Eye Movement Desensitization and Reprocessing helps the brain re-file painful memories so they stop running the present. Gentle, structured, evidence-based." },
    { age: "All ages", title: "Trauma & PTSD", body: "Trauma-informed care that moves at your pace. Safety first, always — nothing is forced, and you set the tempo of every session." },
    { age: "Children, Teens, Adults", title: "Anxiety & Stress", body: "Practical tools for worry, panic, and overwhelm — plus the deeper work of understanding where the alarm bells learned to ring." },
    { age: "All ages", title: "Grief & Loss", body: "Grief is love with nowhere to go. We make room for it — for children who lost someone, and for adults carrying losses of every shape." },
    { age: "Parents & Caregivers", title: "Family & Parent Support", body: "Coaching and collaboration for the grown-ups. You know your child best — therapy works when the whole circle is supported." },
];

export const INSURERS = [
    "Aetna",
    "Cigna",
    "UnitedHealthcare",
    "Magellan",
    "Optum",
    "Oscar",
    "Blue Cross Blue Shield",
];

export const TRAININGS = [
    { tag: "Supervision", title: "Creative Play Therapy Supervision Skills Training", body: "For supervisors and supervisors-to-be: creative, play-based approaches to guiding the next generation of play therapists. Co-led with Alyssa.", href: "https://trainingswithalyssaanddora-trainings.teachable.com/p/creativesupevisionskills" },
    { tag: "Diversity & Inclusion", title: "Neuro-Inclusive Play: Bridging Minds and Cultures", body: "Multicultural & diversity play therapy training — practical tools for making the playroom welcoming to every nervous system and every culture.", href: "https://trainingswithalyssaanddora-trainings.teachable.com/p/bridgingmindsandculturesinmulticulturalanddiversityplaytherapytraining" },
    { tag: "Family Work", title: "Building Stronger Bonds with Parents in the Playroom", body: "Bring caregivers into the work: concrete strategies for turning parents into confident co-therapists in their child's healing.", href: "https://trainingswithalyssaanddora-trainings.teachable.com/p/building-stronger-bonds-with-parents-in-the-playroom" },
    { tag: "EMDR & Polyvagal", title: "Polyvagal Puppet Play — Neuroscience, EMDR & 'Ception Puppets™ Fun!", body: "Dora's signature training: polyvagal theory, EMDR-informed play, and the 'Ception Puppets in action. Listed with EMDRIA.", href: "https://www.emdria.org/course/polyvagal-puppet-play-neuroscience-emdr-and-ception-puppetstm-fun/" },
];

export const FAQS = [
    { q: "What happens at the first session?", a: "The first visit is a gentle getting-to-know-you. For children, that means exploring the playroom while we talk with parents about goals. For adults, it's a conversation about what brought you in and what you'd like to change. No pressure, no paperwork marathons — that all happens beforehand through Headway." },
    { q: "Do you take insurance?", a: "Yes. We partner with Headway to bill many major insurance plans, and you can check your benefits in minutes before booking. Self-pay sessions are $150." },
    { q: "What exactly is play therapy?", a: "Play therapy uses a child's natural language — play — to help them express feelings, process experiences, and build coping skills. Dora is a Registered Play Therapist-Supervisor (RPT-S), the highest credential in the field." },
    { q: "What is EMDR and does it hurt?", a: "EMDR uses gentle bilateral stimulation (eye movements, taps, or tones) while you briefly recall a memory, helping your brain store it without the old charge. Most people find it far gentler than they feared — you stay in control the whole time." },
    { q: "What ages do you work with?", a: "Children as young as 3, teens, and adults. Play therapy serves our youngest clients; EMDR, talk therapy, and trauma work serve teens and grown-ups." },
    { q: "How long are sessions, and how many will we need?", a: "Sessions are typically 50 minutes. Some families see change in a handful of visits; deeper work takes longer. We'll talk openly about progress and you'll never be kept longer than needed." },
    { q: "Do you offer telehealth?", a: "Yes — secure video sessions are available for teens and adults. Young children are usually best served in the playroom, in person." },
    { q: "Is my information private?", a: "Completely. This website collects no health information at all. All intake forms, scheduling, records, and messaging live inside Headway, a HIPAA-compliant platform." },
];
